import type { FC } from "react";
import type { BreakRulesConfig } from "../../../utils/models";
import { requireTransformedRows, transformBreakRulesConfigsForBackend } from "../../../utils/wageRules/forBackend";
import { breakRulesConfigFromApi } from "../../../utils/wageRules/fromApi";
import { getBreakRulesConfigReasons } from "../../../utils/wageRules/validations";
import { BreakRulesConfigTable } from "./BreakRulesConfigTable";
import { matchBreakRulesRows } from "./deepLinkRowMatchers";
import { useSaveBreakRulesConfig } from "./useWageRulesConfig";
import { type RuleSectionProps, WageRulesSection, type WageRulesSectionConfig } from "./WageRulesSection";

const BREAK_RULES_SECTION: WageRulesSectionConfig<BreakRulesConfig> = {
	section: "break_rules",
	stored: (settings) => settings.breakRulesConfig,
	fromApi: breakRulesConfigFromApi,
	forBackend: (rows, roles, jobIds) => requireTransformedRows(transformBreakRulesConfigsForBackend(rows, roles, jobIds)),
	reasons: getBreakRulesConfigReasons,
	Table: BreakRulesConfigTable,
	explainerKey: "team.wageSettings.breakRules.explainer",
	dataTestId: "team-wage-settings-break-rules",
	matchDeepLinkRows: matchBreakRulesRows,
};

/** DAT-905 · Break rules on Team → Wage Settings. They also drive the live lunch-violation reports. */
export const BreakRulesSection: FC<RuleSectionProps> = ({ settings, isReadOnly, deepLink }) => {
	const save = useSaveBreakRulesConfig();
	return <WageRulesSection config={BREAK_RULES_SECTION} settings={settings} save={save} isReadOnly={isReadOnly} deepLink={deepLink} />;
};
